import {manageCurrent} from './manageCurrent'
import {manageProjects} from './manageProjects'
import {manageStyles} from './manageStyles'
import { combineReducers } from 'redux'

const rootReducer = combineReducers({
  projects: manageProjects,
  current: manageCurrent,
  styles: manageStyles
})

export default rootReducer

/* log will have EVERY REQUEST in requestStream */
/* stream will only be for current tab */



// WEBPACK FOOTER //
// ./src/reducers/index.js